export class ChartsOrdersDto {
  static toApi(fieldId, ordersDictionary = {}) {
    const ordersArray = [...Object.entries(ordersDictionary)].map(
      ([chartId, order]) => ({
        chartId,
        order,
      })
    );
    return {
      fieldId,
      chartOrders: ordersArray,
    };
  }
}
